<template>
    <div class="main_wrap">
        <div class="blockHead">
            <p class="blockTitle">
                <span class="back" @click="goBack"><i class="iconfont icon-fanhui mr_5"></i>返回研究报告列表</span>
                <span class="split">|</span>
                <span class="name">{{reportData.sTitle}}</span>
            </p>
        </div>
        <div class="blockBox top_border_blue bc_white shadow">
            <h1 class="fs_24 c_333">{{reportData.sTitle}}</h1>
            <div class="mt_10 c_999 fs_14">
                <i class="el-icon-time mr_5"></i>
                <span>{{reportData.iPublishTime}}</span>
            </div>
        </div>
        <div class="reportDetail bc_white shadow mt_20">
            <div class="reportDetailCon">
                <div class="report_header flex_justify_between">
                    <div class="header_logo"></div>
                    <p>优采研究院<span class="point">•</span>系列研究报告</p>
                </div>
                <div class="report_main mt_20">
                    <!-- 前言 -->
                    <p class="report_txt" v-if="reportData.sBefore">{{reportData.sBefore}}</p>
                    <!-- 主体 -->
                    <div class="mb_10" v-for="(item,index) in reportData.sContent" :key="index">
                        <template v-if="item.type=='txt'">
                            <h1 v-if="item.bigTitle" class="report_title_first mt_16">{{item.bigTitle}}</h1>
                            <h2 v-if="item.littleTitle" class="report_title_second">{{item.littleTitle}}</h2>
                            <p class="report_txt" v-html="item.data"></p>
                        </template>
                        
                        <ChartItem v-if="item.type=='chart' && item.showChart" :chartData="item.data"></ChartItem>

                        <Table v-if="item.type=='table'" :tableData="item.data"></Table>
                    </div>
                    <!-- 结语 -->
                    <p class="report_txt" v-if="reportData.sAfter">{{reportData.sAfter}}</p>
                    <!-- 数据说明 -->
                    <div class="report_description" v-if="descriptionData">
                        <p class="fw_b">{{descriptionData.title}}</p>
                        <ul v-if="descriptionData.value&&descriptionData.value.length">
                            <li v-for="(item,index) in descriptionData.value" :key="index">
                              <span v-if="index !=4" >{{index+1}}.{{item.label}}：{{item.value}}</span>
                              <span v-else @click="gozhiku()" style="cursor: pointer">
                                  {{index+1}}.{{item.label}}：{{item.value}}
                              </span>
                              <ol v-if="item.children">
                                  <li v-for="(children,idx) in item.children" :key="idx"  >
                                   {{idx+1 | circleNum}}.{{children.label}}：{{children.value}}
                                  </li>
                              </ol>
                            </li>
                        </ul>
                    </div>

                    <!-- 结尾署名 -->
                    <div class="report_signature mt_10" v-if="signature">
                        <p>{{signature.title}}</p>
                        <p>{{signature.name}}</p>
                    </div>
                </div>
            </div>

            <!-- 下载 -->
            <div class="report_download flex_center" v-if="reportData">
                <button class="download_btn bg_gradient_blue" @click="toDownload(reportData.sUrl)">
                    <i class="iconfont icon-Group- fs_18"></i>
                    立即下载
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import ChartItem from "./components/Chart";
import Table from "./components/Table";
import mockData from "@/pages/mockData.js";
import ajaxService from '@/server/api.js'
import permission from "@/mixins/permission.js";
export default {
    mixins:[permission],
    data(){
        return {
            reportData:{}||mockData.reportMockData,
            descriptionData:{},//数据说明
            signature:{},//结尾署名
        }
    },
    components: {
        ChartItem,
        Table
    },
    computed: {
        reportId(){
            return this.$route.query.reportId
        },
    },
    created() {
        this.initData()
    },
    methods: {
        // 初始化数据
        initData(){
            let param = {
                id:this.reportId
            }
            this.getChartData(param)//图表数据
        },
        gozhiku(){
          window.open('http://xiazai.dichan.com/information/detail?id=10022437',"_blank")
        },
        // 获取报告数据
        getChartData(param){
            ajaxService.getReportDetail(param).then(res=>{
                console.log('报告数据',res)
                if(!res.ErrorCode){
                    this.reportData=res.Data
                    this.descriptionData=res.Data.sLabel.descriptionData
                    this.signature=res.Data.sLabel.signature
                    this.checkData(res.Data.sContent)

                    document.title=this.reportData.sTitle + " - 优采大数据"
                    // console.log(res.Data.sContent)
                    // console.log(JSON.parse(res.Data.sContent))
                }
            })
        },

        // 检查图表的数据是否有效（不全部为0）
        checkData(arr){
            arr.forEach(item=>{
                if(item.type=="chart"){
                    item.showChart=false
                    if(item.data.chartType=="pie"){
                        item.showChart=!(item.data.chartData.every(i=>{
                            return i.value==0
                        }))
                    }else{
                        item.data.chartData.forEach(i=>{
                            i.value.forEach(val=>{
                                if(val!=0){
                                    item.showChart=true
                                }
                            })
                        })
                    }
                }
            })
        },

        // 下载
        toDownload(downloadUrl){
            window.open(downloadUrl, this.isScreen?'_self':'_blank');
        },

        // 返回
        goBack(){
            this.$router.push({
                path: '/page/report',
                // query:{
                //     module:3,
                // }
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.main_wrap{
    // width: 9rem;
    width: 46.875vw;
}
.blockHead{
    .blockTitle{
        line-height: 4.8vh;
    }
}
.blockBox{
    height: 10.4vh;
    padding: .2rem .3rem;
}
.reportDetail{
    
    height: 74vh;
    margin-top: 1.8vh;
    position: relative;
    .reportDetailCon{
        // position: absolute;
        // left: 0;
        // top: 0;
        width: 100%;
        height: 100%;
        padding: .3rem .8rem;
        box-sizing: border-box;
        overflow-x:hidden;
        overflow-y:auto;
    }
    .report_header{
        height: .5rem;
        border-bottom: .02rem solid #CCCCCC;
        font-size: .16rem;
        color: #666;
        .header_logo{
            width: 2.05rem;
            height: .35rem;
            background-image: url('../../assets/imgs/logo_page.png');
            background-size: 100%;
            background-repeat: no-repeat;
            margin-top: .08rem;
        }
        .point{
            display: inline-block;
            margin: 0 .05rem;
            color: #707070;
        }
    }
    .report_main{
        color: #333;
        font-size: .14rem;
        font-family: 'PingFangSC-Regular';
        line-height: 2;
        padding-bottom: .2rem;
    }

    .report_txt{
        text-indent:.32rem;// 段落第一行缩进
    }

    .report_title_first,.report_title_second{
        color: #333;
        font-weight: bold;
        font-size: .16rem;

        text-indent:.32rem;
    }
    .report_title_second{
        font-size: .14rem;
        // text-indent:.32rem;
    }

    // 数据说明
    .report_description{
        color: #666;
        font-size: .12rem;
        margin-bottom: .3rem;
    }
    // 结尾署名
    .report_signature{
        text-align: right;
    }
    .report_download{
        position: absolute;
        left: 0;
        bottom:0;
        width: 100%;
        height: 5.6vh;
        background: rgba($color: #010101, $alpha: 0.4);
        .download_btn{
            width: 10.4vw;
            height: 3.7vh;
            line-height: 3.7vh;
            border-radius: .04rem;
            color: white;
            text-align: center;
            font-size: .16rem;
            // .icon{
            //     display: inline-block;
            //     margin-right
            // }
        }
    }
}
</style>
<style lang="scss">
.report_txt{
    // span{
    //     color:red;
    // }
}
</style>

